<template>
  <div class="column">
    <div class="card dash-card" v-bind:class="getSizeClass()">
      <div class="card-header dash-card-header">
        <div style="height: 40px;"></div>
      </div>
      <!-- Cluster 6 -->
      <div class="card-body dash-card-body">
        <tableitem :overallByWave="getOverallByWave"
                   :kpi="getKpiCustomerTreatment"
                   :isHeader="true" />
        <titleunderline />
        <div class="dash-card-inner">
          <tableitem :overallByWave="getOverallByWave"
                     :kpi="getKpiRatingOfAppointmentMaking"
                     :hasStar="false"
                     :hasDashBorder="false" />
          <!-- <div style="height: 2px;" /> -->
          <tableitem :overallByWave="getOverallByWave"
                     :kpi="getKpiRatingOfSalesConsultation"
                     :hasStar="false"
                     :hasDashBorder="false" />
          <!-- <div style="height: 2px;" /> -->
          <tableitem :overallByWave="getOverallByWave"
                     :kpi="getKpiConsiderBuyingVehicle"
                     :hasStar="false"
                     :hasDashBorder="true" />
        </div>
        <!-- <div style="height: 18px;" />

        <HeaderedBar :overallItem="getOverallItemProperty"
                     :isPercentage="true"
                     :hasAsterisk="true"
                     :shouldFillGap="true"
                     :title="getTextRecommend()"
                     :proHeader="getText('Promoters')"
                     :contraHeader="getText('Detractors')"
                     :pro="getOverallItemProperty.RecommendationPromoters"
                     :contra="getOverallItemProperty.RecommendationDetractors" />
        -->
        <div style="height: 18px;" />
      </div>
    </div>
    <RecommendationTable :recommend="getOverallRecommendation()"
                         :title="getTextRecommend()"
                         :hasAsterisk="true"
                         :proHeader="getText('Promoters')"
                         :contraHeader="getText('Detractors')"
                         :neutralHeader="getText('Passives')" />
    <!-- Shops Count Stats -->
    <div class="card dash-card" id="shops">
      <div class="card-header dash-card-header" style="height: 30px; background: transparent; ">
        <h3 class="spacing">{{$t('Webportal.DashboardBMW.NumberOfShops')}} <span class="smalltext">({{$t('Webportal.DashboardBMW.Total')}} {{ getShops }})</span></h3>
      </div>
      <div class="card-body dash-card-body">
        <ShopsOverall style="width: 100%; height:127px;"
                      :overallValues="getOverallByWave" />
      </div>
    </div>
    <!-- Legende -->
    <LegendControl :workingStandardsText="getWorkingStandardGroup"
                   :successFactorsText="getSuccessFactorsGroup" />
  </div>
</template>

<script>

  import performanceitem from './PerformanceItem'
  import tableitem from './TableItem.vue'
  import WideNscItem from './WideNscItem.vue'
  import ShopsOverall from './ShopsOverall'
  import HeaderedBar from './HeaderedBar'
  import LegendControl from './LegendControl'
  import RecommendationTable from './RecommendationTable'
  import titleunderline from './TitleUnderline'
  import BrandMixin from '@/mixins/BrandMixin';

  export default {
    name: 'CustomerTreatmentColumn',

    mixins: [BrandMixin],

    components: {
      performanceitem,
      tableitem,
      WideNscItem,
      ShopsOverall,
      HeaderedBar,
      LegendControl,
      RecommendationTable,
      titleunderline
    },

    data() {
      return {
      }
    },

    props: [
      'dashdata',
      'isBmwi',
      'selectedBrand'
    ],

    methods: {
      getText(key) {
        return this.$t('Webportal.DashboardBMW.' + key)
      },

      getBrand() {
        var brands = '';
        this.selectedBrand.forEach(n => {
          if (n.includes('BMW') || n.includes('MINI') && !n.includes('PHEV')) {
            if (brands.length > 0) {
              brands = brands + ', ';
            }
            brands = brands + n.split('^')[1];
          }
        });
        return brands;
      },

      getTextRecommend() {
        return this.$t('Webportal.DashboardBMW.Recommend') + ' ' + this.getBrand()
      },

      getOverallRecommendation() {
        if (this.dashdata && this.dashdata.Recommendation && _.size(this.dashdata.Recommendation) > 0)
          return this.dashdata.Recommendation[0]
      },

      getKpiByString: function (name) {
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0) {
          let item = _.find(this.dashdata.KPI, (x) => x.KpiCode === name)
          if (item) return item
        }
      },

      getKpiGroupByString: function (name) {
        if (this.dashdata && this.dashdata.KPIGroup && _.size(this.dashdata.KPIGroup) > 0)
          return _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === name)
      },

      getOverallItem: function () {
        if (this.dashdata && this.dashdata.Overall && _.size(this.dashdata.Overall) > 0)
          return this.dashdata.Overall[0]
        return undefined
      },

      getSizeClass() {
        if (this.isBmwi) {
          return 'headercard-bmwi'
        }
        return 'headercard-bmw'
      },
    },

    computed: {

      isNsc: function () {
        var _kpi = this.getKpiCustomerTreatment
        if (!_kpi || !_kpi.SurveyWave || _.size(_kpi.SurveyWave) === 0) {
          return false
        }
        var result = _kpi.SurveyWave[0].ResultNSC
        return result != undefined
      },

      getKpiCustomerTreatmentName: function () {
        const item = this.getKpiGroupByString('Customer Treatment')
        if (item) { return item.KpiName }
        return '-'
      },

      getOverallItemProperty: function () {
        return this.getOverallItem()
      },

      getOverallByWave: function () {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      getShops: function () {
        const item = this.getOverallItem()
        if (!item) { return '-' }
        return item.NumberOfShopsTotal
      },

      getKpiCustomerTreatment: function () {
        return this.getKpiGroupByString('Customer Treatment')
      },

      getKpiConsiderBuyingVehicle: function () {
        return this.getKpiByString('06. Consider buying a Vehicle')
      },

      getKpiRatingOfAppointmentMaking: function () {
        return this.getKpiByString('6.1 Rating of appointment making')
      },

      getKpiRatingOfSalesConsultation: function () {
        return this.getKpiByString('6.2 Rating of sales consulation')
      },

      getSuccessFactorsGroup: function () {
        let item = this.getKpiGroupByString('Success factors');
        return !item ? '-' : item.KpiName;
      },
      getWorkingStandardGroup: function () {
        let item = this.getKpiGroupByString('Working Standard');
        return !item ? '-' : item.KpiName;
      },
    }
  }

</script>
<style scoped>

  .left {
    overflow: hidden;
    min-height: 26px;
  }

  .right {
    float: right;
    min-height: 26px;
  }

  .ctNoNsc {
    width: 95%;
    float: left;
    text-align: center;
    margin-top: 3px;
    margin-left: 6px;
    margin-right: 6px;
  }

  .hasnonsc {
    width: 100%;
  }

  .hasnsc {
    width: 65%;
  }

  .hasnonscitem {
    width: 0%;
  }

  .hasnscitem {
    width: 30%;
  }

  .p {
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    -o-hyphens: auto;
    hyphens: auto;
    word-wrap: break-word;
    text-overflow: ellipsis;
    text-overflow: unset;
  }

  .headercard-bmw {
    height: 340px;
  }

  .headercard-bmwi {
    height: 340px;
  }

  .headercard-bmwmoto {
    height: 503px;
  }

  .headercard {
    height: 500px;
  }

  .column {
    margin: 0px;
    padding: 0px;
    min-height: 55px;
    position: relative;
    top: 0px;
    margin-block-end: 0px;
    margin-inline-end: 2px;
  }

  .nscHeader {
    min-height: 77px;
  }

  .noNscHeader {
    min-height: 60px;
  }

  h3 {
    font-size: 10pt;
    margin: 0pt;
    text-align: center;
    font-stretch: extra-condensed;
    letter-spacing: -0.12em;
    white-space: normal;
    margin-top: 4px;
    font-weight: bold;
  }

  .spacing {
    letter-spacing: unset;
  }

  .card-body {
    padding: 0px;
  }
</style>
